import { IssueComponentCategory } from '../types/issues';
import { translate } from '../types/EnumTranslations';
import { resolveBuildComponentTypeTranslation } from './BuildComponentTypesStore';

/**
 * Display text for an issue's component category, "Bastyp – Specifik typ"
 * or just the base type. Prefers the live type-config name and falls back
 * to the label snapshotted when the category was set, so a renamed or
 * deleted type still reads sensibly in old issues.
 */
export const issueComponentCategoryText = (category: IssueComponentCategory): string => {
    const base = translate(category.baseType);
    if (!category.specificType) return base;
    const specific = resolveBuildComponentTypeTranslation(category.specificType) || category.label;
    return specific === base ? base : `${base} – ${specific}`;
};

/**
 * Prefilled title of the work order made from a felanmälan: "{what} – {start
 * of the description}", where `what` is the component's name or the
 * category, else "Felanmälan"; the description is cut at a word near 60
 * characters. Same text as the server's automatic conversion
 * (mf-functions `workOrderTitleFor`) and the iOS form.
 */
export const workOrderTitleFromIssue = (what: string | undefined, description: string): string => {
    const text = description.replace(/\s+/g, ' ').trim();
    const MAX = 60;
    let excerpt = text;
    if (text.length > MAX) {
        const cut = text.slice(0, MAX);
        const lastSpace = cut.lastIndexOf(' ');
        excerpt = `${(lastSpace > 30 ? cut.slice(0, lastSpace) : cut).replace(/[\s,.;:–-]+$/, '')}…`;
    }
    const head = what && what.trim() ? what.trim() : 'Felanmälan';
    return excerpt ? `${head} – ${excerpt}` : head;
};
